import { DataTypes } from "bi-interfaces";
import { IColumns } from 'bi-interfaces/lib/interfaces/IColumns.interface';

export const SA_Attachments_Columns = (currentComponent : any): IColumns[] => {

    return ([
    {
        DomID: "Col_Serial",
        Name: 'Serial',        
        DisplayName: 'Serial',
        DataType: DataTypes.NUMERIC,
        controlType: "numeric",           
        IsEditable: false,
        IsVisible:  false,
        DefaultValue: 0 ,
        IsFilterable: true,
    },
    {
        DomID: "Col_EntityName",
        Name: 'EntityName',        
        DisplayName: 'EntityName',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  false,
        DefaultValue: null ,
        IsFilterable: true,
    },
    {
        DomID: "Col_EntityKey1",
        Name: 'EntityKey1',        
        DisplayName: 'EntityKey1',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  false,
        DefaultValue: null ,
        IsFilterable: true,
    },
    {
        DomID: "Col_EntityKey2",
        Name: 'EntityKey2',        
        DisplayName: 'EntityKey2',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  false,
        DefaultValue: null ,
        IsFilterable: true,
    },
    {
        DomID: "Col_EntityKey3",
        Name: 'EntityKey3',        
        DisplayName: 'EntityKey3',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  false,
        DefaultValue: null ,
        IsFilterable: true,
    },
    {
        DomID: "Col_EntityKey4",
        Name: 'EntityKey4',        
        DisplayName: 'EntityKey4',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  false,
        DefaultValue: null ,
        IsFilterable: true,
    },
    {
        DomID: "Col_EntityKey5",
        Name: 'EntityKey5',        
        DisplayName: 'EntityKey5',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  false,
        DefaultValue: null ,
        IsFilterable: true,
    },
    {
        DomID: "Col_FileName",
        Name: 'FileName',        
        DisplayName: 'FileName',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  true,
        DefaultValue: null ,
        IsFilterable: true,
    },
    {
        DomID: "Col_AttachmentBLOB",
        Name: 'AttachmentBLOB',        
        DisplayName: 'AttachmentBLOB',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  false,
        DefaultValue: null ,
        IsFilterable: true,
    },
    {
        DomID: "Col_AttachmentComments",
        Name: 'AttachmentComments',        
        DisplayName: 'AttachmentComments',
        DataType: DataTypes.Text,
        controlType: "text",           
        IsEditable: true,
        IsVisible:  true,
        DefaultValue: null ,
        IsFilterable: true,
    },
  ])
}
